import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Inver Grove Heights",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Inver Grove Heights Minnesota south metro suburb with Dakota County rolling landscape, Mississippi River bluffs visible in background, residential neighborhoods with tree-lined streets, commercial areas along South Robert Trail, suburban community near St. Paul southern border, warm golden hour photography, no readable signs or text",
  heroImageSeq: "inver-grove-heights-mn-hero-2026",
  heroDescription:
    "Family cruise booked out of Miami and passports expired? Corporate trip to a client in London with 12 days notice? College study abroad application requiring passport renewal? We help Inver Grove Heights residents — from Dakota County families and South Robert Trail professionals to Mississippi River bluff community members — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.8397; -93.0433",
  geoPlacename: "Inver Grove Heights, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/inver-grove-heights/",
  localAreaTitle: "Serving Inver Grove Heights & Southeast Dakota County",
  localAreaText: [
    "Inver Grove Heights, Minnesota is a scenic southeastern Dakota County suburb located along the Mississippi River bluffs, bordered by South St. Paul to the north and Eagan to the west. The city's residential neighborhoods offer a quiet suburban lifestyle with easy access to downtown St. Paul via Highway 52 and I-494. The combination of natural beauty, good schools, and proximity to employment centers makes Inver Grove Heights a sought-after community for families.",
    "The city's commercial corridors along Cahill Avenue and South Robert Street (Highway 3) provide retail, restaurant, and professional services that serve a broad population. Many residents commute to St. Paul, Minneapolis, and the surrounding suburbs for work — in healthcare, government, manufacturing, and professional services. International business travel is common among the professional community.",
    "Inver Grove Heights has a diverse population that includes long-established Dakota County families, recent immigrants, and young professionals who appreciate the city's value and convenience. The city's proximity to the South St. Paul and St. Paul neighborhoods creates a diverse community with strong international connections to Latin America, Eastern Europe, and Southeast Asia.",
    "The rolling terrain and parks of Inver Grove Heights, including Simley Lake and Valley Park, create a family-friendly environment where parents plan international vacations for educational enrichment and adventure. Youth sports and school programs also create travel opportunities that require valid passports.",
  ],
  nearbyCities: [
    { name: "Inver Grove Heights", zips: "55076, 55077" },
    { name: "South St. Paul", zips: "55075" },
    { name: "Eagan", zips: "55121, 55122, 55123" },
    { name: "West St. Paul", zips: "55118" },
    { name: "Sunfish Lake", zips: "55118" },
    { name: "Newport", zips: "55055" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Inver Grove Heights home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any Inver Grove Heights or South St. Paul shipping location.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause costly delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Inver Grove Heights & Southeast Dakota County",
  serviceAreaDescription: "Serving Dakota County and southeast metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Inver Grove Heights, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a post office can take 2–6 months — far too slow for upcoming travel.",
    },
    {
      q: "Can I get a family passport renewal before a cruise?",
      a: "Absolutely. Cruise-bound families from Inver Grove Heights are among our most common clients. We regularly process expedited family renewals and child passports with compressed timelines — as fast as 2–9 business days. Cruise departure dates are fixed, so start as soon as possible.",
    },
    {
      q: "Do I need to visit an office to start the process?",
      a: "No — most Inver Grove Heights residents start online and ship their documents via overnight courier. There is no Fast Passport Center office in Inver Grove Heights. You can ship from nearby FedEx or UPS locations.",
    },
    {
      q: "What if I need a passport for my college student heading to study abroad?",
      a: "We regularly help families process passports for study abroad students. The process is the same as a standard renewal or new passport — we can expedite to meet study abroad program deadlines.",
    },
    {
      q: "My passport expired. Can I renew it without visiting the regional agency?",
      a: "Yes — if you are renewing a standard adult passport issued when you were 16 or older and it was issued within the last 15 years, you can renew by mail. We handle the rest once you ship your documents to us.",
    },
    {
      q: "What are the passport acceptance facilities near Inver Grove Heights?",
      a: "Inver Grove Heights Post Office, the South St. Paul Post Office, and Eagan Post Office all accept passport applications. First-time applicants and minors must visit in person. We guide you through this step.",
    },
  ],
  testimonials: [
    {
      name: "The Anderson Family",
      location: "Inver Grove Heights, MN",
      rating: 5,
      text: "We booked a Caribbean cruise departing from Miami and discovered that both of our kids' passports had expired. We had four weeks. Fast Passport Center processed both child passports in six business days. We made our cruise and had an incredible family vacation. Thank you for the fast and professional service.",
      service: "Child Passport",
    },
    {
      name: "Kevin M.",
      location: "Inver Grove Heights, MN",
      rating: 5,
      text: "I work in manufacturing and received a trade show assignment in Germany with two weeks notice. My passport was within three months of expiration. Fast Passport Center processed my renewal in four business days. I attended the trade show and made valuable connections. Professional service, highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Teresa H.",
      location: "Inver Grove Heights, MN",
      rating: 5,
      text: "My daughter was accepted to a study abroad program in Spain and we realized her passport had expired. The program deadline was three weeks away. Fast Passport Center processed her renewal in five business days. She made the program. This service made a significant difference for our family.",
      service: "Student Passport",
    },
  ],
  nearbyLinks: [
    { name: "Eagan", href: "/cities/eagan" },
    { name: "South St. Paul", href: "/states/minnesota" },
    { name: "Burnsville", href: "/cities/burnsville" },
    { name: "Apple Valley", href: "/cities/apple-valley" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Woodbury", href: "/cities/woodbury" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Inver Grove Heights",
  introDescription: "Fast passport processing for Inver Grove Heights and southeast Dakota County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Inver Grove Heights and southeast metro resources to help you prepare for your next international trip.",
  acceptanceFacilities: [
    {
      name: "Inver Grove Heights Post Office",
      address: "5855 Blaine Ave, Inver Grove Heights, MN 55076",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(651) 457-4175",
      notes: "Primary passport acceptance facility for Inver Grove Heights residents. Appointment required. Call ahead for photo services.",
    },
    {
      name: "South St. Paul Post Office",
      address: "127 5th Ave S, South St. Paul, MN 55075",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 451-3240",
      notes: "Convenient for north Inver Grove Heights residents. Full passport services. Photo services available.",
    },
    {
      name: "Eagan Post Office",
      address: "3983 Rahn Rd, Eagan, MN 55122",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 454-5222",
      notes: "Serves Eagan and Dakota County. Photo services available. Good alternative for west Inver Grove Heights.",
    },
    {
      name: "West St. Paul Post Office",
      address: "111 E Annapolis St, West St. Paul, MN 55118",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 451-0445",
      notes: "Convenient for northwest Inver Grove Heights residents.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Inver Grove Heights", address: "6038 Cahill Ave, Inver Grove Heights, MN 55076", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — South St. Paul", address: "1 Concord Exchange S, South St. Paul, MN 55075", hours: "Call for hours" },
    { name: "CVS Pharmacy — Eagan", address: "1629 Cliff Rd, Eagan, MN 55122", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — Eagan", address: "1286 Promenade Pl, Eagan, MN 55121", hours: "Call for hours" },
    { name: "FedEx Office — St. Paul South", address: "St. Paul south area", hours: "Call for hours" },
    { name: "Walgreens — West St. Paul", address: "226 Wentworth Ave E, West St. Paul, MN 55118", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Dakota County Driver & Vehicle Services",
      address: "Eagan and Hastings area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Dakota County DVS. Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 10 miles from Inver Grove Heights — 15 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary international airport for Inver Grove Heights residents. Access via I-494 westbound. Direct international flights to Europe, Mexico, and the Caribbean.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
  ],
  travelCards: [
    {
      title: "MSP Airport Access",
      subtitle: "Convenient 15-minute drive to international departures",
      content:
        "Inver Grove Heights provides a convenient 15-minute drive to MSP Airport via I-494. This easy airport access is a major advantage for the city's international travelers. With nonstop MSP service to Amsterdam, London, Paris, Tokyo, Reykjavik, and Cancun, residents have excellent international options.",
      tip: "Check passport expiration before booking MSP international flights. Most countries require 6 months validity beyond your return date.",
      icon: "ri-flight-takeoff-line",
    },
    {
      title: "Family Vacation Travel",
      subtitle: "Inver Grove Heights families planning cruises and resort trips",
      content:
        "Inver Grove Heights is a family-oriented community where vacation planning is a major activity. Caribbean cruises, Mexico resort packages, and European river tours are popular choices. These families often book trips 4–6 weeks out and discover passport issues close to departure.",
      tip: "Check every family member's passport when booking any international trip. Children's passports expire in 5 years. Book expedited processing as soon as you discover an issue.",
      icon: "ri-parent-line",
    },
    {
      title: "Manufacturing & Trade Travel",
      subtitle: "Dakota County manufacturing professionals with international business",
      content:
        "The southeast metro has a strong manufacturing and trade base. Many Inver Grove Heights professionals work in manufacturing, distribution, and supply chain with international supplier relationships. Trade shows, supplier visits, and factory inspections in Europe and Asia are common.",
      tip: "Manufacturing professionals should maintain passport validity at all times. Trade show and supplier schedules are fixed.",
      icon: "ri-settings-3-line",
    },
    {
      title: "Study Abroad Planning",
      subtitle: "College students and families preparing for international programs",
      content:
        "Inver Grove Heights families value education and international experience. Many area students apply for study abroad programs in Europe, Latin America, and Asia. Passport processing is often a last-minute realization when program acceptance arrives.",
      tip: "Study abroad students need current passports for program applications. Start the passport process as soon as you begin researching programs.",
      icon: "ri-graduation-cap-line",
    },
  ],
  destinations: [
    {
      name: "Caribbean",
      context: "Cruises from Miami and Fort Lauderdale for Inver Grove Heights families",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun and Riviera Maya for Dakota County family resort vacations",
      urgency: "Resort packages and spring break trips are often booked 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Manufacturing trade shows in Munich, Frankfurt, and Hannover",
      urgency: "Trade show schedules are fixed — expedited processing is often the only option",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Spain",
      context: "Study abroad programs in Madrid, Barcelona, and Seville",
      urgency: "Study abroad deadlines are fixed and non-negotiable",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London for professional meetings and family heritage travel",
      urgency: "Business meetings require passport confirmed well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Philippines",
      context: "Heritage travel for Filipino families in the south metro",
      urgency: "Family visits are often planned 2–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "41%", label: "of Inver Grove Heights expedited requests are cruise or resort travel with fixed departure dates" },
    { stat: "3–4 Weeks", label: "most common advance notice window when Inver Grove Heights travelers contact us" },
    { stat: "May–Sep", label: "peak travel season with the highest volume of expedited passport requests" },
    { stat: "5 Days", label: "average expedited processing time for Inver Grove Heights clients" },
  ],
};

export default function InverGroveHeightsPage() {
  return <CityPage data={data} />;
}